/* ------------------------------------------------------------------
   Mr Football - send the popup's "Who are you shopping for?" answer
   into Klaviyo as a profile property.

   WHY THIS FILE EXISTS SEPARATELY
   -------------------------------
   mf-lucky-popup.js already captures the answer, but only used it for
   two things: the destination of the final button, and a cart attribute
   (`Shopping for`) that rides to the order. Neither reaches the email
   platform, so all three answers landed in list TjcSLL identically and
   triggered the same welcome series. The answer was being collected and
   thrown away.

   This patches it at the Klaviyo boundary rather than editing the popup
   script, so the popup's captcha/fallback logic stays untouched and this
   is removable in one line.

   WHAT IT SETS on the Klaviyo profile:
     Shopping for   -> "Myself" | "My kids" | "Both"   (the literal answer)
     Buys for kids  -> true/false                      (segment-friendly bool)
     Buys for self  -> true/false
     Signup source  -> "Lucky card popup"

   HOW: wraps window.fetch and injects properties into the outgoing
   Klaviyo client/subscriptions payload. The wrapper is deliberately
   narrow - it only touches requests to a.klaviyo.com/client/subscriptions
   and passes everything else straight through untouched. If anything
   throws, the original request is sent unmodified: a signup must never
   be lost to this file.

   The answer is read from the cart attribute the popup already sets, via
   the in-page variable the popup exposes, falling back to reading which
   segment pill was clicked.

   TO REVERT: delete this file and its <script> tag in
   sections/mailing-popup.liquid. Nothing else references it.
------------------------------------------------------------------ */
(function () {
  'use strict';
  if (window.__mfSegmentPatch) { return; }
  window.__mfSegmentPatch = true;

  var answer = '';

  /* Record the click. Capture phase, so this runs before the popup's own
     handler moves the step on. */
  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest && ev.target.closest('[data-mfp-segment]');
    if (!btn) { return; }
    answer = btn.getAttribute('data-mfp-segment') || '';
  }, true);

  function propsFor(a) {
    var lower = String(a || '').toLowerCase();
    var kids = lower.indexOf('kid') !== -1 || lower.indexOf('both') !== -1;
    var self = lower.indexOf('myself') !== -1 || lower.indexOf('both') !== -1;
    return {
      'Shopping for': a,
      'Buys for kids': kids,
      'Buys for self': self,
      'Signup source': 'Lucky card popup'
    };
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch !== 'function') { return; }

  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (answer &&
          url.indexOf('a.klaviyo.com/client/subscriptions') !== -1 &&
          init && typeof init.body === 'string') {
        var payload = JSON.parse(init.body);
        var attrs = payload &&
                    payload.data &&
                    payload.data.attributes &&
                    payload.data.attributes.profile &&
                    payload.data.attributes.profile.data &&
                    payload.data.attributes.profile.data.attributes;
        if (attrs) {
          attrs.properties = Object.assign({}, attrs.properties || {}, propsFor(answer));
          init = Object.assign({}, init, { body: JSON.stringify(payload) });
        }
      }
    } catch (e) {
      /* fall through and send the request exactly as it was */
    }
    return nativeFetch.apply(this, [input, init]);
  };
})();
